'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Cog', 'AVRO.Seasonality.SeasonalityReviewConstants', 'AVRO.Seasonality.Constants'];
module.exports = angular.module('AVRO.Seasonality.PooledReviewToolBar', dependencies).controller('PooledSeasonalityReviewToolbarController', require('./controllers/PooledSeasonalityReviewToolbarController')).directive('rmPooledSeasonalityToolbar', require('./directives/PooledSeasonalityReviewToolbarDirective'));